"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/CampaignPage/Body/MessagesTable/components/TableTopBar.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);





const TableTopBar = ({ children }) => (
  _react2.default.createElement('div', { className: "campaign--table--top-bar", __self: this, __source: {fileName: _jsxFileName, lineNumber: 8}}
    ,  children 
  )
)

exports. default = TableTopBar
